import { isObservable, Observable, of } from 'rxjs';
import { StoreProvider } from './store.provider';

export const applyErrorHandler = (handler: unknown): Observable<unknown> => {
  if (typeof handler === 'function') {
    const errorHandlerResult = handler();
    if (isObservable(errorHandlerResult)) {
      return errorHandlerResult;
    } else {
      return of(null);
    }
  } else {
    return StoreProvider.getStore().dispatch(handler);
  }
};
